<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style lang="scss">
@import '@/style/index.scss';

.searchHistoryDialog .el-dialog__body {
    padding: 0 30px 20px;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    font-family: Microsoft YaHei;
}

.el-autocomplete {
    flex: 1;
}

.imgContent .el-icon-circle-close {
    color: red !important;
    margin-right: 200px;
}

.sendMsgInput .el-input__inner {
    background: #EFF2F7;
}

.searchContacts .el-input__inner {
    border-radius: 40px;
}

.searchCon .el-input--prefix .el-input__inner {
    border: none !important;
    background: #F4F4F4 !important;
}

/* 滚动条 */
::-webkit-scrollbar-thumb:horizontal {
    /*水平滚动条的样式*/
    width: 4px;
    background-color: #cccccc;
    -webkit-border-radius: 6px;
}

::-webkit-scrollbar-track-piece {
    background-color: #eee;
    /*滚动条的背景颜色*/
    -webkit-border-radius: 5px;
    /*滚动条的圆角宽度*/
}

::-webkit-scrollbar {
    width: 10px;
    /*滚动条的宽度*/
    height: 8px;
    /*滚动条的高度*/
}

::-webkit-scrollbar-thumb:vertical {
    /*垂直滚动条的样式*/
    height: 50px;
    background-color: #999;
    -webkit-border-radius: 4px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
}

::-webkit-scrollbar-thumb:hover {
    /*滚动条的hover样式*/
    height: 50px;
    background-color: #9f9f9f;
    -webkit-border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue